import * as React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';

export interface OwnProps {
    showDialog: boolean;
    cancel: () => void;
    title?: string;
    message?: string;
    deleteRecord: () => void;
}

class DeleteSubmissionDialog extends React.PureComponent<OwnProps> {
    public render() {
        return (<Dialog
                    open={this.props.showDialog}
                    onClose={this.props.cancel}
                    aria-labelledby='delete-event'
                    aria-describedby='delete-event'
                >
            <DialogTitle id='delete-row'>{this.props.title || 'Delete record'}</DialogTitle>
            <DialogContent>
                <DialogContentText id='delete-dialog-description'>
                    {this.props.message || 'Are you sure that you want to delete this record(s)?'}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={this.props.deleteRecord} color='primary'>
                    Delete
                </Button>
                <Button onClick={this.props.cancel} color='primary' autoFocus={true}>
                    Cancel
                </Button>
            </DialogActions>
        </Dialog>)
    }
}

export default DeleteSubmissionDialog;